import React from 'react';

const Footer = () => {
  return (
    <footer
      className="bg-surface-container-lowest border-t border-outline-variant pt-20 pb-12"
      role="contentinfo"
      data-testid="app-footer"
    >
      <div className="max-w-container-max mx-auto px-margin-desktop">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-gutter mb-20">

          {/* Brand block */}
          <div className="col-span-1 md:col-span-1">
            <a href="/" className="inline-flex items-center gap-2.5 no-underline mb-6" aria-label="CONSAI Home" data-testid="footer-logo">
              <img src="/consai-logo.png" alt="CONSAI" className="h-8 w-auto" />
              <span className="horizon-font tracking-widest" style={{ fontSize: '17px' }}>
                <span style={{ color: '#ffffff' }}>CONS</span><span style={{ color: '#d7263d' }}>AI</span>
              </span>
            </a>
            <p className="font-body-sm text-body-sm text-on-surface-variant leading-relaxed">
              Executive precision for Indian SMBs. Revolutionizing business management through voice-first AI.
            </p>
          </div>

          {/* Product links */}
          <div>
            <h5 className="font-body-md font-bold text-primary mb-6">Product</h5>
            <ul className="space-y-4 list-none p-0 m-0">
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="#features">Features</a></li>
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="#pricing">Pricing</a></li>
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="#">Integrations</a></li>
            </ul>
          </div>

          {/* Company links */}
          <div>
            <h5 className="font-body-md font-bold text-primary mb-6">Company</h5>
            <ul className="space-y-4 list-none p-0 m-0">
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="#">About</a></li>
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="mailto:consai.india@gmail.com">Contact Support</a></li>
              <li><a className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline" href="#">API Documentation</a></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h5 className="font-body-md font-bold text-primary mb-6">Connect</h5>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/consai.in/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full executive-border flex items-center justify-center hover:bg-primary hover:text-background transition-all no-underline"
                data-testid="footer-social-instagram"
              >
                <span className="material-symbols-outlined text-sm">share</span>
              </a>
              <a
                href="mailto:consai.india@gmail.com"
                aria-label="Email"
                className="w-10 h-10 rounded-full executive-border flex items-center justify-center hover:bg-primary hover:text-background transition-all no-underline"
                data-testid="footer-social-email"
              >
                <span className="material-symbols-outlined text-sm">alternate_email</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-12 border-t border-outline-variant flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="font-body-sm text-body-sm text-on-surface-variant">
            &copy; {new Date().getFullYear()} CONSAI, a BUFFETISM IT VENTURES PRIVATE LIMITED company.
          </div>
          <div className="flex gap-8">
            <a
              href="/privacy-policy"
              className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline"
              data-testid="footer-privacy"
            >
              Privacy Policy
            </a>
            <a
              href="/terms-and-conditions"
              className="font-body-sm text-body-sm text-on-surface-variant hover:text-primary transition-colors no-underline"
              data-testid="footer-terms"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
